import React from 'react'

const Advertisement = () => {
  return (
    <div></div>
  )
}

export default Advertisement